export default __webpack_public_path__ + "static/file-sharing-3d14cac0779195aad968fc3e68a80079.png";